import * as PIXI from 'pixi.js';
import type { Game } from './Game';

export abstract class Scene {
  readonly container = new PIXI.Container();

  constructor(readonly game: Game) {}

  abstract enter(): void;
  abstract exit(): void;

  fixedUpdate?(_dt: number, _tick: number): void;
  onResize?(_width: number, _height: number): void;

  get app(): PIXI.Application {
    return this.game.app;
  }

  get camera() {
    return this.game.camera;
  }

  get input() {
    return this.game.input;
  }

  get entities() {
    return this.game.entities;
  }

  get time() {
    return this.game.time;
  }
}
